import {
  Avatar,
  Badge,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Grid,
  Input,
  Layout,
  Modal,
  Progress,
  Row,
  Table,
  Tabs,
  Tag,
  Space,
  Typography,
  Upload,
  Tooltip,
} from "antd";
import {
  ArrowUpOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  UserOutlined,
  IdcardOutlined,
  LogoutOutlined,
  SafetyCertificateOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { message } from "antd";
import { useState, useContext } from "react";
import MakePaymentModal from "../components/makePaymentModal";
import InvestModal from "../components/investmentModal";
import ApplyForNewLoanModal from "../components/applyforNewLoan";
import { AppContext } from "../context/AppContext";
import axios from "axios";

const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { Column } = Table;
const { useBreakpoint } = Grid;

const documents = [
  { name: "national_id.pdf", type: "National ID", status: "Verified" },
];

const BorrowerProfile = () => {
  const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false);
  const [isLoanModalVisible, setIsLoanModalVisible] = useState(false);
  const [isInvestModalVisible, setIsInvestModalVisible] = useState(false);
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const { user } = useContext(AppContext);
  const [isEditingDetails, setIsEditingDetails] = useState(false);
  const [borrowerDetails, setBorrowerDetails] = useState({
    phone: user?.phone || "",
    address: user?.address || "",
    employer: user?.employer || "",
    next_kin_name: user?.next_kin_name || "",
    next_kin_phone: user?.next_kin_phone || "",
  });
  const token = localStorage.getItem("token");
  console.log("User data:", user);

  const transactions =
    user?.loans?.flatMap(
      (loan) =>
        loan.loan_transactions?.map((transaction) => ({
          key: transaction.id,
          date: transaction.transaction_date,
          description: transaction.transaction_type,
          amount: transaction.amount,
          type: transaction.amount > 0 ? "credit" : "debit",
        })) || []
    ) || [];

  // Financial data
  const creditScore = user?.credit_score || 650;
  const totalInvested = 7500; // Added

  const loanBalance =
    user?.loans?.reduce(
      (sum, loan) => sum + (loan.next_payment_amount || 0),
      0
    ) || 0;

  const [nextOfKin, setNextOfKin] = useState({
    name: user?.next_kin_name || "",
    relationship: user?.next_kin_relationship || "",
    phone: user?.next_kin_phone || "",
    email: user?.next_kin_email || "",
    address: user?.next_kin_address || "",
  });
  const [isEditingKin, setIsEditingKin] = useState(false);

  const handleKinInfoChange = (field, value) => {
    setNextOfKin((prev) => ({ ...prev, [field]: value }));
  };

  const handleBorrowerDetailsChange = (field, value) => {
    setBorrowerDetails((prev) => ({ ...prev, [field]: value }));
  };

  const handleSaveBorrowerDetails = async () => {
    try {
      const response = await axios.patch(
        `https://zedlenders.pickmesms.com/users/${user.id}`,
        borrowerDetails,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.data) {
        // Update local context with new data
        // This would ideally update the AppContext user data
        setIsEditingDetails(false);
        message.success("Borrower details updated successfully!");
      }
    } catch (error) {
      message.error(
        error.response?.data?.errors?.[0]?.message ||
          "Failed to update borrower details. Please try again."
      );
    }
  };

  const setSelectedFile = (file) => {
    console.log("Selected file:", file);
  };

  const getCreditScoreColor = (score) => {
    // Define your credit score ranges and corresponding colors
    if (score < 580) {
      // Poor
      return {
        "0%": "#ff4d4f",
        "100%": "#cf1322", // Red gradient
      };
    } else if (score >= 580 && score < 670) {
      // Fair
      return {
        "0%": "#faad14",
        "100%": "#d48806", // Orange gradient
      };
    } else if (score >= 670 && score < 740) {
      // Good
      return {
        "0%": "#a0d911",
        "100%": "#7cb305", // Lime gradient
      };
    } else {
      // Excellent (740+)
      return {
        "0%": "#52c41a",
        "100%": "#389e0d", // Green gradient
      };
    }
  };

  return (
    <Layout
      style={{
        padding: isMobile ? 12 : 24,
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        minHeight: "100vh",
      }}
    >
      {/* Profile Header - Mobile Optimized */}
      <Card
        style={{
          marginBottom: 24,
          background: "linear-gradient(135deg, #078930 0%, #4CAF50 100%)", // Zambian brand colors
          border: "none",
          borderRadius: 16,
          boxShadow: "0 8px 32px rgba(7, 137, 48, 0.3)",
          overflow: "hidden",
        }}
        bodyStyle={{ padding: isMobile ? 16 : 32 }}
      >
        <Row gutter={24} align="middle">
          <Col>
            <Avatar
              size={isMobile ? 64 : 80}
              icon={<UserOutlined />}
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.95)",
                color: "#078930",
                boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
                border: "3px solid rgba(255, 255, 255, 0.5)",
                fontSize: isMobile ? 24 : 32,
              }}
            />
          </Col>
          <Col flex="auto">
            <Title
              level={isMobile ? 5 : 4}
              style={{ marginBottom: 0, color: "#fff" }} // White text
            >
              {user?.first_name} {user?.last_name}
            </Title>
            <Text
              type="secondary"
              style={{ fontSize: isMobile ? 12 : 14, color: "#e0e0e0" }} // Light gray text
            >
              NRC : {user.nrc}
            </Text>
          </Col>
          <Col>
            <Button
              icon={<LogoutOutlined />}
              size={isMobile ? "middle" : "large"}
              onClick={() => {
                // Proper logout - clear all localStorage before redirecting
                console.log("Logout clicked");
                localStorage.clear();
                localStorage.setItem("isAuth", "false");
                window.location.href = "/app";
              }}
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.95)",
                color: "#078930",
                border: "2px solid rgba(255, 255, 255, 0.5)",
                borderRadius: "12px",
                fontWeight: "600",
                boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
                height: isMobile ? "40px" : "48px",
              }}
            >
              {isMobile ? "" : "Logout"}
            </Button>
          </Col>
        </Row>
      </Card>

      {/* Financial Overview Grid */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        {/* Credit Score Column */}
        <Col xs={24} lg={8}>
          <Card
            title="💳 Credit Health"
            style={{
              height: "100%",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
              border: "none",
              background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
            }}
            headStyle={{
              borderBottom: "2px solid #f0f0f0",
              fontSize: "18px",
              fontWeight: "700",
              color: "#078930",
            }}
          >
            <Tooltip title={`Credit Score: ${creditScore}`}>
              <div style={{ textAlign: "center" }}>
                <Progress
                  type="circle"
                  percent={(creditScore / 850) * 100}
                  strokeWidth={12}
                  width={isMobile ? 140 : 180}
                  strokeColor={getCreditScoreColor(creditScore)}
                  trailColor="#e8f5e8"
                  strokeLinecap="round"
                  format={() => (
                    <div style={{ textAlign: "center" }}>
                      <Title
                        level={isMobile ? 3 : 2}
                        style={{
                          marginBottom: 0,
                          color: "#078930",
                          fontWeight: 700,
                          textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        {creditScore}
                      </Title>
                      <Text
                        type="secondary"
                        style={{
                          fontSize: isMobile ? 12 : 14,
                          color: "#666",
                          fontWeight: 500,
                        }}
                      >
                        {creditScore > 800
                          ? "AAA (Exceptional)"
                          : creditScore > 750
                          ? "AA+ (Excellent)"
                          : creditScore > 700
                          ? "AA (Very Strong)"
                          : creditScore > 650
                          ? "A+ (Strong)"
                          : creditScore > 600
                          ? "A (Good)"
                          : creditScore > 550
                          ? "BBB (Adequate)"
                          : creditScore > 500
                          ? "BB (Speculative)"
                          : creditScore > 400
                          ? "B (High Risk)"
                          : "CCC/C (Default Risk)"}
                      </Text>
                    </div>
                  )}
                  style={{ transition: "all 0.3s", cursor: "pointer" }}
                  className="hover-scale" // Add a CSS class for hover effect
                />
              </div>
            </Tooltip>
          </Card>
        </Col>

        {/* Quick Actions Column */}
        <Col xs={24} lg={16}>
          <Row gutter={[16, 16]}>
            {/* Loan Services */}
            <Col xs={24} md={12}>
              <Card
                title="🏦 Loan Services"
                style={{
                  borderRadius: "16px",
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
                  border: "none",
                  background:
                    "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
                }}
                headStyle={{
                  borderBottom: "2px solid #f0f0f0",
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "#078930",
                }}
              >
                <Space direction="vertical" style={{ width: "100%" }}>
                  <Button
                    type="primary"
                    block
                    size="large"
                    onClick={() => setIsLoanModalVisible(true)}
                    style={{
                      backgroundColor: "#078930",
                      borderColor: "#078930",
                      borderRadius: "12px",
                      height: "48px",
                      fontWeight: "600",
                      fontSize: "16px",
                      boxShadow: "0 4px 12px rgba(7, 137, 48, 0.3)",
                    }}
                  >
                    🎯 Apply for New Loan
                  </Button>
                  <Button
                    block
                    size="large"
                    icon={<DollarOutlined />}
                    onClick={() => setIsPaymentModalVisible(true)}
                    style={{
                      borderColor: "#078930",
                      color: "#078930",
                      borderRadius: "12px",
                      height: "48px",
                      fontWeight: "600",
                      fontSize: "16px",
                      background:
                        "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
                    }}
                  >
                    💰 Make Payment
                  </Button>
                  <Divider style={{ margin: "12px 0" }} />
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #fee7e7 0%, #fecaca 100%)",
                      padding: "16px",
                      borderRadius: "12px",
                      border: "1px solid #fca5a5",
                      marginTop: "8px",
                    }}
                  >
                    <FinancialInfoItem
                      label="💸 Total Loan Balance"
                      value={`K${loanBalance.toLocaleString()}`}
                      type="danger"
                    />
                  </div>
                </Space>
              </Card>
            </Col>

            {/* Investment Section */}
            <Col xs={24} md={12}>
              <Card
                title="📈 My Investments"
                style={{
                  borderRadius: "16px",
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
                  border: "none",
                  background:
                    "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
                }}
                headStyle={{
                  borderBottom: "2px solid #f0f0f0",
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "#FF8C00",
                }}
              >
                <Space direction="vertical" style={{ width: "100%" }}>
                  <Button
                    type="primary"
                    block
                    size="large"
                    onClick={() => setIsInvestModalVisible(true)}
                    style={{
                      backgroundColor: "#FF8C00",
                      borderColor: "#FF8C00",
                      borderRadius: "12px",
                      height: "48px",
                      fontWeight: "600",
                      fontSize: "16px",
                      boxShadow: "0 4px 12px rgba(255, 140, 0, 0.3)",
                    }}
                  >
                    🚀 Invest Now
                  </Button>
                  <Divider style={{ margin: "12px 0" }} />
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
                      padding: "16px",
                      borderRadius: "12px",
                      border: "1px solid #86efac",
                      marginBottom: "8px",
                    }}
                  >
                    <FinancialInfoItem
                      label="💰 Total Invested"
                      value={`K${totalInvested.toLocaleString()}`}
                      type="success"
                    />
                  </div>
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%)",
                      padding: "16px",
                      borderRadius: "12px",
                      border: "1px solid #fdba74",
                    }}
                  >
                    <FinancialInfoItem
                      label="🎯 Expected Maturity"
                      value={`K${(totalInvested * 1.15).toLocaleString()}`}
                      type="secondary"
                    />
                  </div>
                </Space>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* Borrower Details Card */}
      <Card
        title="👤 Borrower Details"
        style={{
          marginBottom: 24,
          borderRadius: "16px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
          border: "none",
          background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
        }}
        headStyle={{
          borderBottom: "2px solid #f0f0f0",
          fontSize: "18px",
          fontWeight: "700",
          color: "#078930",
        }}
        extra={
          <Button
            icon={
              isEditingDetails ? (
                <SafetyCertificateOutlined />
              ) : (
                <UserOutlined />
              )
            }
            onClick={() =>
              isEditingDetails
                ? handleSaveBorrowerDetails()
                : setIsEditingDetails(true)
            }
            style={{
              backgroundColor: isEditingDetails ? "#078930" : "transparent",
              borderColor: "#078930",
              color: isEditingDetails ? "#fff" : "#078930",
              borderRadius: "8px",
              fontWeight: "600",
            }}
          >
            {isEditingDetails ? "💾 Save Details" : "✏️ Edit Details"}
          </Button>
        }
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Form.Item label="Phone Number">
              {isEditingDetails ? (
                <Input
                  value={borrowerDetails.phone}
                  onChange={(e) =>
                    handleBorrowerDetailsChange("phone", e.target.value)
                  }
                  addonBefore="+260"
                  placeholder="97 123 4567"
                />
              ) : (
                <Text strong>
                  <a href={`tel:${borrowerDetails.phone}`}>
                    {borrowerDetails.phone}
                  </a>
                </Text>
              )}
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item label="Employer">
              {isEditingDetails ? (
                <Input
                  value={borrowerDetails.employer}
                  onChange={(e) =>
                    handleBorrowerDetailsChange("employer", e.target.value)
                  }
                  placeholder="Employer name"
                />
              ) : (
                <Text strong>
                  {borrowerDetails.employer || "Not specified"}
                </Text>
              )}
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Physical Address">
              {isEditingDetails ? (
                <Input.TextArea
                  rows={3}
                  value={borrowerDetails.address}
                  onChange={(e) =>
                    handleBorrowerDetailsChange("address", e.target.value)
                  }
                  placeholder="Enter full physical address"
                />
              ) : (
                <Text strong>{borrowerDetails.address}</Text>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Card>

      {/* Transaction History with Mobile Scroll */}
      <Card
        title="📊 Transaction History"
        style={{
          marginBottom: 24,
          borderRadius: "16px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
          border: "none",
          background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
        }}
        headStyle={{
          borderBottom: "2px solid #f0f0f0",
          fontSize: "18px",
          fontWeight: "700",
          color: "#078930",
        }}
      >
        <Table
          dataSource={transactions}
          pagination={false}
          scroll={{ x: true }}
          size={isMobile ? "small" : "middle"}
        >
          <Column title="Date" dataIndex="date" key="date" />
          <Column
            title="Description"
            dataIndex="description"
            key="description"
          />
          <Column
            title="Amount"
            dataIndex="amount"
            key="amount"
            render={(amount) => (
              <Text
                strong
                style={{ color: amount > 0 ? "#52c41a" : "#ff4d4f" }}
              >
                K{Math.abs(amount).toFixed(2)}
              </Text>
            )}
          />
        </Table>
      </Card>

      {/* Document Upload Section */}
      <Card
        title="📁 Document Center"
        style={{
          marginBottom: 24,
          borderRadius: "16px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
          border: "none",
          background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
        }}
        headStyle={{
          borderBottom: "2px solid #f0f0f0",
          fontSize: "18px",
          fontWeight: "700",
          color: "#078930",
        }}
      >
        <Tabs defaultActiveKey="1">
          <TabPane
            tab={
              <span>
                <IdcardOutlined /> Identity Documents
              </span>
            }
            key="1"
          >
            <Upload.Dragger
              multiple
              beforeUpload={() => false}
              onChange={(info) => setSelectedFile(info.file)}
              style={{
                padding: 32,
                borderRadius: "12px",
                border: "2px dashed #078930",
                background: "linear-gradient(135deg, #f0f9f0 0%, #e8f5e8 100%)",
              }}
            >
              <p className="ant-upload-drag-icon">
                <UploadOutlined style={{ fontSize: 48, color: "#078930" }} />
              </p>
              <p
                className="ant-upload-text"
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#078930",
                }}
              >
                📁 Click or drag National ID to upload
              </p>
              <p
                className="ant-upload-hint"
                style={{ fontSize: "14px", color: "#666", marginTop: "8px" }}
              >
                Supports: PDF, JPG, PNG (Max 5MB)
              </p>
            </Upload.Dragger>
          </TabPane>

          <TabPane
            tab={
              <span>
                <FileTextOutlined /> Financial Documents
              </span>
            }
            key="2"
          >
            <Table
              dataSource={documents}
              style={{
                background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
                borderRadius: "12px",
                overflow: "hidden",
              }}
            >
              <Column
                title="📄 Document Name"
                dataIndex="name"
                key="name"
                render={(name) => (
                  <Text strong style={{ color: "#078930" }}>
                    {name}
                  </Text>
                )}
              />
              <Column
                title="📂 Type"
                dataIndex="type"
                key="type"
                render={(type) => (
                  <Text style={{ color: "#666", fontWeight: "500" }}>
                    {type}
                  </Text>
                )}
              />
              <Column
                title="✅ Status"
                dataIndex="status"
                key="status"
                render={(status) => (
                  <Tag
                    color={status === "Verified" ? "green" : "gold"}
                    style={{
                      borderRadius: "8px",
                      fontWeight: "600",
                      padding: "4px 12px",
                    }}
                  >
                    {status === "Verified" ? "✅ Verified" : "⏳ Pending"}
                  </Tag>
                )}
              />
            </Table>
          </TabPane>
        </Tabs>
      </Card>
      <Card
        title="👨‍👩‍👧‍👦 Next of Kin Information"
        style={{
          marginBottom: 24,
          borderRadius: "16px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
          border: "none",
          background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
        }}
        headStyle={{
          borderBottom: "2px solid #f0f0f0",
          fontSize: "18px",
          fontWeight: "700",
          color: "#078930",
        }}
        extra={
          <Button
            icon={
              isEditingKin ? <SafetyCertificateOutlined /> : <UserOutlined />
            }
            onClick={() => {
              if (isEditingKin) {
                // Save next of kin data to API
                const nextOfKinData = {
                  next_kin_name: nextOfKin.name,
                  next_kin_relationship: nextOfKin.relationship,
                  next_kin_phone: nextOfKin.phone,
                  next_kin_email: nextOfKin.email,
                  next_kin_address: nextOfKin.address,
                };
                axios
                  .patch(
                    `https://zedlenders.pickmesms.com/users/${user.id}`,
                    nextOfKinData,
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                      },
                    }
                  )
                  .then((response) => {
                    if (response.data.data) {
                      message.success(
                        "Next of kin details updated successfully!"
                      );
                      setIsEditingKin(false);
                    }
                  })
                  .catch((error) => {
                    message.error(
                      error.response?.data?.errors?.[0]?.message ||
                        "Failed to update next of kin details. Please try again."
                    );
                  });
              } else {
                setIsEditingKin(true);
              }
            }}
            style={{
              backgroundColor: isEditingKin ? "#078930" : "transparent",
              borderColor: "#078930",
              color: isEditingKin ? "#fff" : "#078930",
              borderRadius: "8px",
              fontWeight: "600",
            }}
          >
            {isEditingKin ? "💾 Save Details" : "✏️ Edit Details"}
          </Button>
        }
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Form.Item label="Full Name">
              {isEditingKin ? (
                <Input
                  value={nextOfKin.name}
                  onChange={(e) => handleKinInfoChange("name", e.target.value)}
                  placeholder="Enter full name"
                />
              ) : (
                <Text strong>{nextOfKin.name}</Text>
              )}
            </Form.Item>

            <Form.Item label="Relationship">
              {isEditingKin ? (
                <Input
                  value={nextOfKin.relationship}
                  onChange={(e) =>
                    handleKinInfoChange("relationship", e.target.value)
                  }
                  placeholder="Relationship to borrower"
                />
              ) : (
                <Tag color="blue">{nextOfKin.relationship}</Tag>
              )}
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item label="Contact Phone">
              {isEditingKin ? (
                <Input
                  value={nextOfKin.phone}
                  onChange={(e) => handleKinInfoChange("phone", e.target.value)}
                  addonBefore="+260"
                  placeholder="97 123 4567"
                />
              ) : (
                <Text strong>
                  <a href={`tel:${nextOfKin.phone}`}>{nextOfKin.phone}</a>
                </Text>
              )}
            </Form.Item>

            <Form.Item label="Email Address">
              {isEditingKin ? (
                <Input
                  type="email"
                  value={nextOfKin.email}
                  onChange={(e) => handleKinInfoChange("email", e.target.value)}
                  placeholder="email@example.com"
                />
              ) : (
                <Text strong>
                  <a href={`mailto:${nextOfKin.email}`}>{nextOfKin.email}</a>
                </Text>
              )}
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Physical Address">
              {isEditingKin ? (
                <Input.TextArea
                  rows={3}
                  value={nextOfKin.address}
                  onChange={(e) =>
                    handleKinInfoChange("address", e.target.value)
                  }
                  placeholder="Enter full physical address"
                />
              ) : (
                <Text strong>{nextOfKin.address}</Text>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <MakePaymentModal
        visible={isPaymentModalVisible}
        onCancel={() => setIsPaymentModalVisible(false)}
      />
      <ApplyForNewLoanModal
        user={user}
        visible={isLoanModalVisible}
        onCancel={() => setIsLoanModalVisible(false)}
      />
      <InvestModal
        visible={isInvestModalVisible}
        onCancel={() => setIsInvestModalVisible(false)}
      />
    </Layout>
  );
};

// Reusable financial item component
const FinancialInfoItem = ({ label, value, type = "default" }) => {
  const textColor = {
    default: "#2D3748",
    secondary: "#718096",
    success: "#38A169",
    warning: "#DD6B20",
    danger: "#E53E3E",
  }[type];

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "4px 0",
      }}
    >
      <Text type="secondary" style={{ fontSize: 14 }}>
        {label}
      </Text>
      <Text strong style={{ color: textColor, fontSize: 14 }}>
        {value}
      </Text>
    </div>
  );
};

export default BorrowerProfile;
